export default __webpack_public_path__ + "bml-video99c597.png";